<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-8 col-lg-4">
                    <div class="form-group">
                      <label for="nom"
                        >Nom de l'abonnement
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('nom'),
                        }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Nom de l'abonnement"
                        maxlength="100"
                        required
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-2 mt-n2 mt-md-0">
                    <div class="form-group">
                      <label for="date_debut"
                        >Date début <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_debut"
                        name="date_debut"
                        placeholder="Date début"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                        @change="resetPlanning"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_debut'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_debut"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2 mt-n2 mt-lg-0">
                    <div class="form-group">
                      <label for="date_fin"
                        >Date fin <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_fin"
                        name="date_fin"
                        placeholder="Date fin"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                        @change="resetPlanning"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_fin'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_fin"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-2 mt-n2 mt-lg-0">
                    <div class="form-group">
                      <label for="frequence"
                        >Fréquence <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="frequences"
                        :reduce="(frequence) => frequence.uuid"
                        v-model="form.frequence"
                        placeholder="Fréquence"
                        @input="resetPlanning"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="frequence"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('frequence'),
                          }"
                        />
                        <has-error :form="form" field="frequence"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2 mt-n2 mt-lg-0">
                    <div class="form-group">
                      <label for="montant_prevu">Montant prévu </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('montant_prevu'),
                        }"
                        id="montant_prevu"
                        v-model="montant_prevu"
                        type="text"
                        placeholder="Montant prévu"
                        @focus="$event.target.select()"
                      />
                      <has-error :form="form" field="montant_prevu"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 mt-n2 mt-lg-0">
                    <div class="form-group">
                      <label for="centre_cout"
                        >Centre de coût
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="centreCouts"
                        :reduce="(centreCout) => centreCout.uuid"
                        v-model="form.centre_cout"
                        placeholder="Centre de coût"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="centre_cout"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('centre_cout'),
                          }"
                        />
                        <has-error :form="form" field="centre_cout"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 mt-n2 mt-lg-0">
                    <div class="form-group">
                      <label for="ligne_budgetaire"
                        >Ligne budgétaire
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="ligneBudgetaires"
                        :reduce="(ligneBudgetaire) => ligneBudgetaire.uuid"
                        v-model="form.ligne_budgetaire"
                        placeholder="Ligne budgétaire"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="ligne_budgetaire"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('ligne_budgetaire'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="ligne_budgetaire"
                        ></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2 mt-n2 mt-lg-0">
                    <div class="form-group">
                      <label for="devise"
                        >Devise <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="symbole"
                        :options="devises"
                        :reduce="(devise) => devise.uuid"
                        v-model="form.devise"
                        placeholder="Devise"
                      >
                        <template v-slot:option="{ symbole }">
                          <h5 style="margin: 0">{{ symbole }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="devise"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('devise'),
                          }"
                        />
                        <has-error :form="form" field="devise"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4 mt-n4">
          <div class="col-md-12 text-center">
            <button
              type="button"
              class="btn btn-secondary"
              @click="generatePlanning"
            >
              Vérifier et générer le planning
            </button>
          </div>
        </div>
        <b-alert
          :show="planningErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="planningErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-5">Période</th>
                  <th class="col-6 text-center">Montant prévu</th>
                  <th class="col-1 text-center">
                    <a class="cursor-pointer" @click.prevent="addItem">
                      <i class="fa fa-plus font-size-17 text-success"></i
                    ></a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in form.plannings"
                  :key="index"
                  class="d-flex"
                >
                  <td class="col-5" style="vertical-align: middle">
                    <date-picker
                      v-model="item.periode"
                      placeholder="Période"
                      lang="fr"
                      format="DD/MM/YYYY"
                      value-type="DD/MM/YYYY"
                    ></date-picker>
                  </td>
                  <td class="col-6" style="vertical-align: middle">
                    <input
                      class="form-control"
                      id="montant_prevu"
                      v-model.number="item.montant_prevu"
                      type="text"
                      placeholder="Montant prévu"
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i class="fa fa-trash font-size-17 text-danger"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="form.plannings.length === 0" class="d-flex">
                  <td colspan="3" class="text-center col-12">Pas de données</td>
                </tr>
              </tbody>
              <tfoot class="font-weight-bold font-size-18">
                <tr class="d-flex">
                  <td class="text-right col-6">TOTAL</td>
                  <td class="text-right col-6">
                    {{ formatWithCurrency(total, symbole) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/abonnement/abonnement';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
      form: new Form({
        date_debut: '',
        date_fin: '',
        nom: '',
        frequence: '',
        centre_cout: '',
        devise: '',
        ligne_budgetaire: '',
        plannings: [],
      }),
      frequences: [],
      centreCouts: [],
      devises: [],
      ligneBudgetaires: [],
      montant_prevu: 0,

      planningErrorMessage: null,
      title: 'Gestion des abonnements - Edition',
    };
  },
  watch: {
    montant_prevu() {
      this.form.plannings.map((p) => {
        return (p.montant_prevu = this.montant_prevu);
      });
    },
  },
  computed: {
    symbole() {
      if (this.form.devise) {
        let obj = window._.find(
          this.devises,
          (d) => d.uuid === this.form.devise
        );
        if (obj) return obj.symbole;
        return this.getCurrency().symbole || '';
      }
      return this.getCurrency().symbole || '';
    },
    total() {
      return window._.sumBy(
        this.form.plannings,
        (item) => Number(item.montant_prevu) * 1
      );
    },
  },
  components: {
    DatePicker,
  },
  methods: {
    init() {
      this.id = this.$route.params.id;
      this.frequences = [];
      this.centreCouts = [];
      this.devises = [];
      this.ligneBudgetaires = [];

      window.axios
        .all([
          window.axios.get(URL.GET_REQUIREMENTS),
          window.axios.get(URL.ABONNEMENT + '/' + this.id, {
            params: {
              edit: true,
            },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.frequences = resp1.data.frequences;
            this.centreCouts = resp1.data.centre_couts;
            this.devises = resp1.data.devises;
            this.ligneBudgetaires = resp1.data.ligne_budgetaires;
            Object.assign(this.form, resp2.data.abonnement);
          })
        )
        .catch();
    },
    resetPlanning() {
      this.form.plannings = [];
    },
    generatePlanning() {
      this.planningErrorMessage = null;
      this.form
        .post(URL.GENERATE_PLANNING)
        .then((resp) => {
          this.form.plannings = resp.data.plannings;
          this.form.plannings.map((p) => {
            return (p.montant_prevu = this.montant_prevu);
          });
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (values, key) => {
            if (key.includes('plannings')) {
              this.planningErrorMessage = values[0];
            }
            return 0;
          });
        });
    },
    submit() {
      this.planningErrorMessage = null;

      this.form
        .put(URL.ABONNEMENT + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (values, key) => {
            if (key.includes('plannings')) {
              this.planningErrorMessage = values[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
